<form [formGroup]="form">
  <ng-container *ngFor="let setting of formSettings">
    @if(setting.Visible) {
    @if(setting.FieldId != 'MobilePhone') {
    <app-text-field [settings]="setting" [value]="setting.Value" (valueChange)="modelChange(setting.FieldId, $event)" (focusChanged)="focusChange($event)" [form]="form"></app-text-field>
    }
    @else {
      @if(setting.Visible && setting.FieldId == 'MobilePhone') { <app-phone-field [settings]="setting" [value]="setting.Value" (valueChange)="modelChange(setting.FieldId, $event)" (focusChanged)="focusChange($event)" [form]="form"></app-phone-field> }
    }
    }

  </ng-container>
</form>

